import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { format } from 'date-fns'
import { useContext, useEffect, useState } from 'react'
import { inputContext } from '../../context/inputsContext'
import useData from '../Data/useData'
import Spinner from '../shared/Spinner'
import Header from './Header'
import { dwellingTooltip, loyaltyTooltip } from './helper'
import Info from './Info'
import Title from './Title'

const KPI = () => {
  const { values } = useContext(inputContext)

  const [data, setData] = useState<
    { name: string; data: number; tooltip: string }[]
  >([])
  const [loyalty, setLoyalty] = useState<
    { name: string; data: number; tooltip: string }[]
  >([])

  const visits = useData()

  useEffect(() => {
    if (!visits) {
      setData([])
      setLoyalty([])
      return
    }

    let total = 0

    const totals = Object.values(visits.visits).reduce(
      (prev, curr) => {
        if (!curr) {
          return prev
        }
        total += curr.noOfVisits
        return {
          '5+ hours': prev['5+ hours'] + curr.dwell.fiveHour.noOfVisits,
          '2-5 hours': prev['2-5 hours'] + curr.dwell.twoHour.noOfVisits,
          '1-2 hours': prev['1-2 hours'] + curr.dwell.oneHour.noOfVisits,
          '20-60 minutes':
            prev['20-60 minutes'] + curr.dwell.twentyMin.noOfVisits,
          '5-20 minutes': prev['5-20 minutes'] + curr.dwell.fiveMin.noOfVisits,
        }
      },
      {
        '5+ hours': 0,
        '2-5 hours': 0,
        '1-2 hours': 0,
        '20-60 minutes': 0,
        '5-20 minutes': 0,
      },
    )

    setData(
      Object.entries(totals).map(([key, item]) => {
        return {
          name: key,
          data: Math.round((item / total) * 100),
          tooltip: dwellingTooltip[key as keyof typeof dwellingTooltip],
        }
      }),
    )
    setLoyalty(
      Object.entries(visits.kpi).map(([key, item]) => {
        return {
          name: key,
          data: item,
          tooltip: loyaltyTooltip[key as keyof typeof loyaltyTooltip],
        }
      }),
    )
  }, [visits])

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          width: '100%',
          minHeight: '100vh',
          zIndex: 100,
        },
      }}
    >
      <Paper square elevation={1}>
        <Box p={2}>
          <Header
            date={`${
              values.startDate
                ? format(new Date(values.startDate), 'dd/MM/yyyy')
                : 'select a start date'
            } to ${
              values.endDate
                ? format(new Date(values.endDate), 'dd/MM/yyyy')
                : 'select a end date'
            }`}
            title={`${values.location?.name ? values.location.name : ''} KPI's`}
          />
          <Title title="Dwell" />
          {!visits && (
            <Box minHeight="100px" position={'relative'}>
              <Spinner />
            </Box>
          )}
          {data.map((item, i) => {
            return (
              <Info
                key={i}
                name={item.name}
                data={(item.data?.toString() || '0') + '%'}
                tooltip={item.tooltip}
              />
            )
          })}
          <Title title="Loyalty" />
          {!visits && (
            <Box minHeight="100px" position={'relative'}>
              <Spinner />
            </Box>
          )}
          {loyalty.map((item, i) => {
            return (
              <Info
                key={i}
                name={item.name}
                data={(item.data?.toString() || 0) + '%'}
                tooltip={item.tooltip}
              />
            )
          })}
        </Box>
      </Paper>
    </Box>
  )
}

export default KPI
